import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-list-group q-w-100"
}
const _hoisted_2 = ["checked", "onChange"]
const _hoisted_3 = { class: "serp__filter--label q-mx-2" }
const _hoisted_4 = {
  key: 0,
  class: "serp__filter--count q-figure-caption"
}
const _hoisted_5 = {
  key: 1,
  class: "q-ps-2"
}


import {useFiltersStore} from '@/store/SerpPage/FiltersStore'

interface FilterValue {
  id: string | number
  label: string
  count?: number
  aggregations?: FilterValue[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterCheckboxRecursive',
  props: {
    values: {},
    field: {}
  },
  setup(__props: any) {

const filtersStore = useFiltersStore()

const props = __props

function onCheckboxChange(label: string) {
  filtersStore.updateCategoryItem(props.field, label)
}

return (_ctx: any,_cache: any) => {
  const _component_FilterCheckboxRecursive = _resolveComponent("FilterCheckboxRecursive", true)!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.values, (item) => {
    return (_openBlock(), _createElementBlock("li", {
      key: item.id,
      class: "serp__filter--checkbox q-px-0"
    }, [
      (item.label)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("label", {
              class: "q-list-group-item q-py-1 q-px-2",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("input", {
                type: "checkbox",
                class: "serp__filter--checkbox-input q-form-check-input q-me-1",
                checked: _unref(filtersStore).filterIsChecked(_ctx.field, item.label),
                onChange: ($event: any) => (onCheckboxChange(item.label))
              }, null, 40, _hoisted_2),
              _createElementVNode("span", _hoisted_3, _toDisplayString(item.label), 1),
              (item.count)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, " (" + _toDisplayString(item.count) + ") ", 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      (item.aggregations && item.aggregations.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
            _createVNode(_component_FilterCheckboxRecursive, {
              values: item.aggregations,
              field: _ctx.field
            }, null, 8, ["values", "field"])
          ]))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}
}

})